import React, { useState } from 'react';
import api from '../utils/apiClient';

const CompraNotification = ({ noti }) => {
  // Settlement notis ("Ganador de subasta…") carry subastaID and get the
  // one-click sale registration; manual purchase requests don't.
  const [ventaMsg, setVentaMsg] = useState('');
  const [registrando, setRegistrando] = useState(false);
  const [registrada, setRegistrada] = useState(false);

  const contact = async () => {
    const numero = noti.numero
    const numericPhoneNumber = numero.replace(/\D/g, '');
    const convertedPhoneNumber = '504' + numericPhoneNumber;
    const message = `buen dia le saludo de parte del equipor de honduautos` ;
    const url = 'https://wa.me/' + convertedPhoneNumber + '?text=' + encodeURIComponent(message)
    await window.open(url, '_blank')
  }

  // Books the win exactly like the manual sold-flow, but the backend derives
  // buyer and amount (the winning bid) from the settled auction itself.
  const registrarVenta = async () => {
    setRegistrando(true);
    setVentaMsg('');
    try {
      await api.post('ventas/venta-subasta/' + noti.subastaID, {});
      setRegistrada(true);
      setVentaMsg('Venta registrada: el carro quedó vendido al ganador con saldo por su oferta.');
    } catch (error) {
      const msg = error.response?.data?.error || 'No se pudo registrar la venta';
      setVentaMsg(msg);
      // "ya fue registrada" / "ya fue vendido" also mean there's nothing left to do.
      if (/ya fue/.test(msg)) setRegistrada(true);
    } finally {
      setRegistrando(false);
    }
  };

  return (
    <div className="column-content-n">
      <p className="from">De: {noti.Mensajero?.nombre || 'Usuario eliminado'}</p>
      <p className="to">Para: ADMINISTRACION</p>
      <p className="notification-content">{noti.body}</p>
      <div className="buttons-notification">
        <button className="button-n" onClick={contact}>Contactarse con el solicitante</button>
        {noti.subastaID && !registrada && (
          <button className="button-n" onClick={registrarVenta} disabled={registrando}>
            {registrando ? 'Registrando…' : 'Registrar venta al ganador'}
          </button>
        )}
      </div>
      {ventaMsg && <p className="notification-content">{ventaMsg}</p>}
    </div>
  );
};

export default CompraNotification;
